export default function TeamDetailsPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <h1 className="text-2xl font-bold">Team Details</h1>
      <p>Team details functionality coming soon...</p>
    </div>
  )
}